import type { SVGProps } from "react"
import React from "react"

export const YoutubeColor: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      d="M1.96394 8.69847C2.07641 6.96704 3.46845 5.61012 5.20141 5.52427C7.71084 5.39994 11.2975 5.25 14 5.25C16.7025 5.25 20.2892 5.39994 22.7986 5.52427C24.5315 5.61012 25.9236 6.96704 26.0361 8.69847C26.1438 10.3573 26.25 12.3985 26.25 14C26.25 15.6015 26.1438 17.6427 26.0361 19.3015C25.9236 21.033 24.5315 22.3899 22.7986 22.4757C20.2892 22.6001 16.7025 22.75 14 22.75C11.2975 22.75 7.71084 22.6001 5.20141 22.4757C3.46845 22.3899 2.07641 21.033 1.96394 19.3015C1.85619 17.6427 1.75 15.6015 1.75 14C1.75 12.3985 1.85619 10.3573 1.96394 8.69847Z"
      fill="#FC0D1B"
    />
    <path d="M11.375 10.5V17.5L18.375 14L11.375 10.5Z" fill="white" />
  </svg>
)
